<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/bUI4VT/images/cover.jpg?1702297693066" alt="This image is the cover for the book Favorite Son"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Favorite Son
      </h1>
      <p class="bookDescription body article font2">
        <b>“Fast, characterful, intricate, surprising</b><b> . . . </b><b>Sohmer knows his way around television, politics, Washington and suspense fiction.”</b> <b>—</b><b><i>Los Angeles Times Book Review</i></b><br/>  <br/> It begins with an assassination. A Nicaraguan freedom fighter is gunned down on live TV while being welcomed to the United States by Sen. Terry Fallon. Though shot and wounded, Fallon, an up-and-coming political star from Texas, survives, and milks the spotlight with help from his ambitious and fiercely loyal press aide Sally Crain.<br/>  <br/> As the nominating convention looms on the horizon, incumbent president, Samuel Baker, faces an uphill battle in his fight for a second term. His campaign needs an injection of new blood—and who better than Fallon, the newly crowned hero? But Baker’s existing vice president isn’t going down without a fight . . .<br/>  <br/> Thrust into the hunt for the assassin, two FBI agents, a grizzled veteran, and a brash rookie, soon learn that nothing is as it seems in the corridors—and bedrooms—of power. Political operatives fight tooth and nail to control the narrative, secrets are exposed and exploited, and a deadly virus is weaponized, all to cover up a conspiracy that could topple the American government. <br/>  <br/> But for the most dangerous man in the world, everything is falling into place, making it easier than ever for his ascendency . . .<br/>  <br/><b>“Extremely good reading.”</b> <b>—</b><b><i>The Washington Post Book World</i></b><br/>  <br/><b>“Outstanding.”</b> <b>—</b><b><i>The Cincinnati Post</i></b><br/>  <br/><b>“Intensely plotted, fast-moving.”</b> <b>— </b><b><i>Publishers Weekly</i></b><br/>  <br/><b>“Exciting, scandalous.”</b> <b>—</b><b><i>Kirkus Reviews</i></b><br/>  <br/><b>“Top-notch thriller fiction</b><b> . . . </b><b>Irresistible.”</b> <b>—</b><b><i>Booklist</i></b><br/>  
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Steve Sohmer
      </h2>
      
      <p class="authorDescription body article">Steve Sohmer, born in Savannah, Georgia, in 1941, is a Shakespearean scholar, an author of fiction and nonfiction books, a television writer and producer, and the former CEO and president of Columbia Pictures. He published his first novel&#160;<I>The Way It Was&#160;</I>in 1966 and later earned his PhD in Shakespearean studies from Oxford University in 1995. His novel&#160;<I>Favorite Son&#160;</I>was made into a miniseries aired by NBC in 1988. Sohmer currently teaches at UCLA.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?c925eed4